import component from './PageQuiz.vue'
export default component
